import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import mapLocations from './map/map_locations.vue';
import GmapCluster from 'vue2-google-maps/dist/components/cluster'; // replace src with dist if you have Babel issues

const el = document.querySelector('.map-locations');

if (el) {
  Vue.use(VueGoogleMaps, {
    load: {
      key: wp.api.gmap,
      libraries: 'places'
    },
    installComponents: true
  });

  Vue.component('GmapCluster', GmapCluster);

  Vue.prototype.window = window;

  document.addEventListener('DOMContentLoaded', (e) => {
    if (el) {
      new Vue({
        el,
        components: {
          mapLocations
        }
      });
    }
  });
}
